const paymentMethods = [
    {
        key: 0,
        label: lang.cash,
    },
    {
        key: 1,
        label: lang.online_payment,
    },
]

export const paymentTypeMap = {
    PAYMENT_METHOD_FPX          : 1,
    PAYMENT_METHOD_EWALLET      : 1 << 1,
    PAYMENT_METHOD_CREDIT_CARD  : 1 << 2,
    PAYMENT_METHOD_COD          : 1 << 3,
    PAYMENT_METHOD_CHOOSE_AT_KIPLE  : 1 << 4,   // Redirect to Kiple to select payment mode instead of selecting at Orderlah page
}

// Please update also Bill.php when update this list
export const dineInPaymentTypeMap = {
    PAYMENT_METHOD_CASH         : 1,
    PAYMENT_METHOD_BOOST        : 2,
    PAYMENT_METHOD_CREDIT_CARD  : 3,
    PAYMENT_METHOD_GRABPAY      : 4,
    PAYMENT_METHOD_MAYBANK_QRPAY: 5,
    PAYMENT_METHOD_TNG          : 6,
}

export const paymentTypes = [
    {
        key: paymentTypeMap.PAYMENT_METHOD_FPX,
        label: "Online Banking (FPX)",
    },
    {
        key: paymentTypeMap.PAYMENT_METHOD_EWALLET,
        label: "eWallet (EW)",
    },
    {
        key: paymentTypeMap.PAYMENT_METHOD_CREDIT_CARD,
        label: "Credit Card (CC)",
    },
    {
        key: paymentTypeMap.PAYMENT_METHOD_COD,
        label: "Cash On Delivery (COD)",
    },
    {
        key: paymentTypeMap.PAYMENT_METHOD_CHOOSE_AT_KIPLE,
        label: "Choose at Kiple",
        admin_hint: "Usually for merchant that use own Kiple account",
    },
]

// Please update also Bill.php when update this list
export const dineInPaymentTypes = [
    {
        key     : dineInPaymentTypeMap.PAYMENT_METHOD_CASH,
        label   : lang.cash,
        logo    : null,
    },
    {
        key     : dineInPaymentTypeMap.PAYMENT_METHOD_CREDIT_CARD,
        label   : "Credit Card",
        logo    : "/storage/payment_methods/visa-master.png",
    },
    {
        key     : dineInPaymentTypeMap.PAYMENT_METHOD_TNG,
        label   : "TNG",
        logo    : "/storage/payment_methods/tng.png",
    },
    {
        key     : dineInPaymentTypeMap.PAYMENT_METHOD_BOOST,
        label   : "Boost",
        logo    : "/storage/payment_methods/boost.png",
    },
    {
        key     : dineInPaymentTypeMap.PAYMENT_METHOD_MAYBANK_QRPAY,
        label   : "Maybank QRPay",
        logo    : "/storage/payment_methods/maybank-qr-pay.png",
    },
    {
        key     : dineInPaymentTypeMap.PAYMENT_METHOD_GRABPAY,
        label   : "GrabPay",
        logo    : "/storage/payment_methods/grab-pay.png",
    },
]


export default paymentMethods;